'use client'

// src/components/weather/symbol.ts
var SYMBOLS = {
  Imperial: "\xB0F",
  Metric: "\xB0C"
};

export {
  SYMBOLS
};
//# sourceMappingURL=chunk-A4XRECLB.mjs.map